<template>
  <Drawer
    v-model="drawerOpened"
    :width="
      user.superAdmin ||
      arrayIntersection(
        ['factoryLeader', 'deliveryLeader', 'deliveryAssist'],
        user.simpleRole
      ).length > 0
        ? 850
        : 400
    "
  >
    <p slot="header">
      <span>运输单</span>
    </p>
    <!-- 左侧选择列 -->
    <div class="menu-panel">
      <!-- 客户 -->
      <div :class="{ 'menu-item': true, 'menu-selected': selectedMenuItem === 0 }">
        <h4>客户</h4>
        <h3>{{ salesOrder ? salesOrder.customer.name : "" }}</h3>
        <h4>产品</h4>
        <h2>
          {{
          salesOrder &&
          salesOrder.material &&
          salesOrder.material.name
          }}
        </h2>
        <h4>数量（吨）</h4>
        <h2>{{ salesOrder && salesOrder.volPlan }}</h2>
        <h4>需求时间</h4>
        <h2>{{ salesOrder && convertTimeDisplay(salesOrder.planArrivedAt) }}</h2>
      </div>
      <!-- 车辆 -->
      <div
        :class="{
          'menu-item': true,
          'menu-selected': selectedMenuItem === 'vehicle',
        }"
        @click="selectVehicleMenuMethod"
      >
        <h4>车牌</h4>
        <div class="plate selected">
          {{
          (selectedVehicle && selectedVehicle.plate) ||
          (delivery && delivery.vehicle && delivery.vehicle.plate)
          }}
        </div>
        <h4>仓位容积（吨）</h4>
        <div class="storageSection-wrap">
          <h3
            v-for="(v, index) in convertStorageSection(selectedVehicle)"
            style="display: inline; margin-right: 12px"
            :key="index"
          >{{ v }}</h3>
        </div>
      </div>
      <!-- 司机 -->
      <div
        :class="{
          'menu-item': true,
          'menu-selected': selectedMenuItem === 'driver',
        }"
        @click="selectDriverMenuMethod"
      >
        <h4>司机</h4>
        <h3>{{ selectedDriver?selectedDriver.map((e) => e.name).join(", ") : "-" }}</h3>
      </div>
      <!-- 出发时间 -->
      <div
        :class="{
          'menu-item': true,
          'menu-selected': selectedMenuItem === 'schedule',
        }"
        @click="selectedMenuItem = 'schedule'"
      >
        <h4>出发时间（计划）</h4>
        <h3>
          {{
          convertTimeDisplay(
          updateContent.departAtPlan || (delivery && delivery.departAtPlan)
          )
          }}
        </h3>
      </div>
    </div>
    <!-- 右侧 -->
    <div
      class="info-panel"
      v-if="
        user.superAdmin ||
        arrayIntersection(
          ['factoryLeader', 'deliveryLeader', 'deliveryAssist'],
          user.simpleRole
        ).length > 0
      "
    >
      <!-- 车辆 -->
      <div v-if="selectedMenuItem === 'vehicle'">
        <h4>更换车辆（双击快速更换）</h4>
        <div v-if="vehicleList.length !== 0" class="info-box vehicle-list">
          <div
            v-for="v in vehicleList"
            @click="selectVehicle(v)"
            @dblclick="confirmClicked"
            :key="v._id"
          >
            <div
              :class="{
                plate: true,
                selected: selectedVehicle && selectedVehicle._id === v._id,
              }"
              style="margin: 8px"
            >
              <span>{{ v.plate.slice(0, 2) }} {{ v.plate.slice(2) }}</span>
            </div>
          </div>
        </div>

        <Alert v-else type="warning" style="margin-top: 8px">目前还没有录入车辆，请前往【车辆信息】页面录入。</Alert>

        <!-- <Divider/> -->
        <h4>车辆信息</h4>
        <div class="info-box">
          <Row>
            <Col span="7">
              <h4>车牌</h4>
              <h3>{{ (selectedVehicle && selectedVehicle.plate) || "-" }}</h3>
            </Col>
            <Col span="6">
              <h4>名字</h4>
              <h3>{{ (selectedVehicle && selectedVehicle.name) || "-" }}</h3>
            </Col>
            <Col span="6">
              <h4>仓位容积（吨）</h4>
              <h3>{{ (selectedVehicle && selectedVehicle.capacity) || "-" }}</h3>
            </Col>
            <Col span="5">
              <h4>默认司机</h4>
              <h3>
                {{
                (selectedVehicle && selectedVehicle.defaultDriver.name) || "-"
                }}
              </h3>
            </Col>
          </Row>
          <Row style="margin-top: 12px">
            <h4>仓位容积（吨）</h4>
            <h3
              v-for="(v, index) in convertStorageSection(selectedVehicle)"
              style="float: left; margin-right: 12px"
              :key="index"
            >{{ v }}</h3>
          </Row>

          <h4 style="margin: 18px 0 12px 0">运输记录（最近5条）</h4>
          <Table :columns="vehicleHistColumns" :data="vehicleHistTableData" size="small"></Table>
        </div>
      </div>
      <!-- 司机 -->
      <div v-if="selectedMenuItem === 'driver'">
        <h4>更换司机</h4>
        <div v-if="driverList.length !== 0" class="info-box vehicle-list">
          <div v-for="driver in driverList" @click="selectDriver(driver)" :key="driver._id">
            <div
              :class="{
                plate: true,
                selected: selectedDriver.map((e) => e._id).includes(driver._id),
              }"
              style="margin: 8px"
            >
              <span>{{ driver.name }}</span>
            </div>
          </div>
        </div>
        <Alert v-else type="warning" style="margin-top: 8px">目前还没有录入司机，请前往【用户和权限】页面录入。</Alert>

        <h4 style="margin: 18px 0 12px 0">运输记录（最近5条）</h4>
        <Table :columns="vehicleHistColumns" :data="vehicleHistTableData" size="small"></Table>
      </div>
      <!-- 出发时间 -->
      <div v-if="selectedMenuItem === 'schedule'">
        <h4>出发时间（计划）</h4>
        <div style="width: 180px; margin-bottom: 20px; float: left">
          <DatePicker
            v-model="selected.departAtPlanDate"
            type="date"
            style="width: 150px; margin-right: 16px"
            placeholder="选择日期"
          ></DatePicker>
        </div>
        <div style="width: 150px; margin-bottom: 20px; float: left">
          <TimePicker
            format="HH:mm"
            style="width: 112px"
            v-model="selected.departAtPlanTime"
            placeholder="选择时间"
          ></TimePicker>
        </div>

        <div class="date-option-cell-list" style="width: 100%; margin-top: 20px">
          <div
            v-for="d in dateOption"
            :key="d.name"
            @click="departAtPlanBtnClick(d.addDates)"
            :class="{
              'date-option-cell': true,
              'date-selected': d.addDates === dateOptionValue,
            }"
          >{{ d.name }}</div>
        </div>

        <div class="date-option-cell-list">
          <div
            v-for="t in timeOption"
            :key="t.name"
            @click="selected.departAtPlanTime = t.time"
            :class="{
              'date-option-cell': true,
              'date-selected': t.time === selected.departAtPlanTime,
            }"
          >{{ t.time }}</div>
        </div>
      </div>
    </div>

    <div v-if="JSON.stringify(updateContent) !== '{}'" class="footer">
      <Button
        :disabled="false"
        type="primary"
        size="large"
        :loading="confirmBtnLoading"
        @click="confirmClicked"
        style="width: 150px; margin-left: 12px"
      >保存</Button>
    </div>
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions, mapGetters } from "vuex";
import { arrayIntersection } from "@/utils";

export default {
  name: "EditDeliveryDrawer",
  props: {},
  data() {
    return {
      drawerOpened: false,
      confirmBtnLoading: false,
      showVInfo: false,
      delivery: null,
      salesOrder: null,
      selectedVehicle: null,
      selectedDriver: [],
      selected: {
        departAtPlanDate: null,
        departAtPlanTime: null
      },
      timeOption: [
        { ampm: "am", time: "08:00" },
        { ampm: "am", time: "09:00" },
        { ampm: "am", time: "10:00" },
        { ampm: "am", time: "11:00" },
        { ampm: "pm", time: "12:00" },
        { ampm: "pm", time: "13:00" },
        { ampm: "pm", time: "14:00" },
        { ampm: "pm", time: "15:00" },
        { ampm: "pm", time: "16:00" },
        { ampm: "pm", time: "17:00" },
        { ampm: "pm", time: "18:00" },
        { ampm: "pm", time: "19:00" },
        { ampm: "pm", time: "20:00" },
        { ampm: "pm", time: "21:00" }
      ],
      dateOption: [
        { name: "今天", addDates: 0 },
        { name: "明天", addDates: 1 },
        { name: "后天", addDates: 2 }
      ],
      updateContent: {},
      selectedMenuItem: "vehicle",
      vehicleHistColumns: [
        {
          title: "车辆",
          key: "vehicle",
          render: (h, params) => h("span", params.row.vehicle.plate || "未安排")
        },
        {
          title: "销售项目",
          key: "sales",
          render: (h, params) =>
            h(
              "span",
              params.row.salesOrder.sales
                ? params.row.salesOrder.sales.abbr
                : params.row.salesOrder.customer.name +
                    "-" +
                    params.row.salesOrder.material.name
            )
        },
        {
          title: "司机",
          key: "driver",
          render: (h, params) =>
            h("span", params.row.driver.map(e => e.name).join(", "))
        },
        {
          title: "需求时间",
          key: "arrivedAt",
          render: (h, params) => {
            if (params.row.departAtPlan) {
              return h(
                "span",
                dayjs(params.row.departAtPlan).format("MM-DD HH:mm")
              );
            } else {
              return null;
            }
          }
        }
      ],
      vehicleHistTableData: []
    };
  },
  watch: {
    "selected.departAtPlanTime": function(n, o) {
      if (!n) return;
      const departAtPlan = dayjs(this.selected.departAtPlanDate)
        .hour(parseInt(n.substring(0, 2)))
        .minute(parseInt(n.substring(3)))
        .second(0)
        .millisecond(0);

      if (
        dayjs(this.delivery.departAtPlan).diff(departAtPlan, "minutes") === 0
      ) {
        delete this.updateContent.departAtPlan;
      } else {
        this.updateContent.departAtPlan = departAtPlan;
      }
    },
    "selected.departAtPlanDate": function(n, o) {
      if (!n) return;
      let timeInt = [0, 0];
      if (this.selected.departAtPlanTime)
        timeInt = [
          parseInt(this.selected.departAtPlanTime.substring(0, 2)),
          parseInt(this.selected.departAtPlanTime.substring(3))
        ];
      const departAtPlan = dayjs(n)
        .hour(timeInt[0])
        .minute(timeInt[1])
        .second(0)
        .millisecond(0);

      if (
        dayjs(this.delivery.departAtPlan).diff(departAtPlan, "minutes") === 0
      ) {
        delete this.updateContent.departAtPlan;
      } else {
        this.updateContent.departAtPlan = departAtPlan;
      }
    }
  },
  computed: {
    ...mapGetters("vehicle", ["getVehicleById"]),
    ...mapState({
      vehicleList: state => state.vehicle.vehicleList,
      driverList: state => state.user.simpleUserList,
      user: state => state.auth.currentUser
    }),
    dateOptionValue: function() {
      if (this.selected.departAtPlanDate === null) return;
      return (
        dayjs(this.selected.departAtPlanDate).get("date") - dayjs().get("date")
      );
    }
  },
  methods: {
    arrayIntersection() {
      return arrayIntersection;
    },
    ...mapActions({
      updateDelivery: "delivery/updateDeliveryAction",
      getDeliveryList: "delivery/getDeliveryListAction",
      getVehicleList: "vehicle/getVehicleListAction",
      getSimpleUserList: "user/getSimpleUserListAction",
      getDeliveryHistory: "delivery/getDeliveryHistoryAction"
    }),
    selectDriverMenuMethod() {
      this.selectedMenuItem = "driver";
      const driverArray = this.selectedDriver.map(x => x._id);
      if (driverArray.length > 0)
        return this.loadVehicleHist({ driver: driverArray.join(",") });
      this.loadVehicleHist();
    },
    selectVehicleMenuMethod() {
      this.selectedMenuItem = "vehicle";
      if (this.selectedVehicle) {
        this.loadVehicleHist({ vehicle: this.selectedVehicle._id });
      }
    },
    async confirmClicked() {
      this.updateContent.departAtPlan = dayjs(
        this.updateContent.departAtPlan
      ).toDate();
      try {
        await this.updateDelivery({
          id: this.delivery._id,
          data: this.updateContent
        });
        this.$Message.success(`保存成功`);
        this.drawerOpened = false;
      } catch (error) {
        this.$Message.error(`保存失败：${error}`);
      }
    },
    openDrawer(delivery, salesOrder, openPage) {
      this.updateContent = {};
      this.drawerOpened = true;
      this.delivery = delivery;
      this.salesOrder = salesOrder;
      this.selectedVehicle = delivery.vehicle;
      if (JSON.parse(JSON.stringify(delivery.driver))) {
        this.selectedDriver = JSON.parse(JSON.stringify(delivery.driver));
      } else {
        this.selectedDriver = [];
      }
      this.selectedMenuItem = openPage;
      if (this.selectedVehicle) {
        const fullInfoVehicle = this.vehicleList.find(
          x => x._id === this.selectedVehicle._id
        );
        if (fullInfoVehicle) this.selectedVehicle = fullInfoVehicle; // 获取更多车辆信息
        this.loadVehicleHist({ vehicle: this.selectedVehicle._id });
      }
      this.selected.departAtPlanDate = this.delivery?.departAtPlan;
      this.selected.departAtPlanTime = this.delivery.departAtPlan
        ? dayjs(this.delivery.departAtPlan).format("HH:mm")
        : null;
    },
    convertStorageSection(vehicle) {
      if (vehicle && vehicle.storageSection.length === 0) return ["无"];
      let result = [];
      vehicle &&
        vehicle.storageSection.forEach(e => {
          result.push(`${e.name}: ${e.capacity}`);
        });
      return result;
    },
    convertTimeDisplay(time) {
      if (!time) return "-";
      return dayjs(time).format("MM-DD HH:mm");
    },
    selectVehicle(v) {
      if (this.selectedVehicle && this.selectedVehicle._id === v._id) return;
      this.selectedVehicle = v;
      if (this.delivery.vehicle && v._id === this.delivery.vehicle._id) {
        delete this.updateContent.vehicle;
      } else {
        this.updateContent.vehicle = v._id;
      }
      this.loadVehicleHist({ vehicle: v._id });
    },
    selectDriver(driver) {
      const openedDriverIdList = this.delivery.driver?.map(e => e._id);
      if (this.selectedDriver.map(e => e._id).includes(driver._id)) {
        this.selectedDriver = this.selectedDriver.filter(
          e => e._id !== driver._id
        );
      } else {
        this.selectedDriver.push(driver);
      }
      const selectedDriverIdList = this.selectedDriver.map(e => e._id);
      if (
        openedDriverIdList &&
        JSON.stringify(openedDriverIdList.sort()) ===
          JSON.stringify(selectedDriverIdList.sort())
      ) {
        delete this.updateContent.driver;
      } else {
        this.updateContent.driver = selectedDriverIdList;
      }
      this.selectDriverMenuMethod();
    },
    async loadVehicleHist(payload) {
      this.vehicleHistTableData = [];
      if (!payload) return;
      try {
        this.vehicleHistTableData = await this.getDeliveryHistory({
          ...payload,
          limit: 5
        });
      } catch (error) {}
    },
    departAtPlanBtnClick(addDates) {
      this.selected.departAtPlanDate = dayjs()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .add(addDates, "d")
        .toDate();
    }
  },
  async created() {
    this.getVehicleList({limit: 99, invalid: false});
    this.getSimpleUserList({ simpleRole: "driver", limit: 99 });
  }
};
</script>

<style scoped lang="stylus">
@import './EditDeliveryDrawer.styl'
</style>
